
































import Vue from 'vue'

export default Vue.extend({
  name: 'PasswordCheckEmail',
  props: {
    email: String
  },
  methods: {
    tryAnother: function (): void {
      this.$emit('forgot-revert')
    }
  }
})
